<!-- Until candidate-status responds (or fails) the button is laid out but hidden, with the skeleton
     drawn exactly over it - same size, so nothing around it moves when the button appears -->
<div class="pipeline-btn-wrapper" [class.pipeline-btn-loading]="isPipelineStatusLoading">
@if(isPipelineStatusLoading) {
<div class="sk-box pipeline-btn-skeleton"></div>
}
@if(calledFrom == 'search' || calledFrom == 'my-candidates') {
<div class="dropdown add-to" (clickOutside)="closeDropdown()">
  <button data-testid="auto-app-add-to-pipeline-button-1" class="btn-trms-medium dropdown-toggle w-100" [ngClass]="{'rotate-caret':isDropdownOpen}"  type="button"
    [disabled]="isAddToPipelineLoading"
    (click)="!isAddToPipelineLoading && toggleDropdown()">
     <span [ngClass]="{ 'spinner-border spinner-size': isAddToPipelineLoading }"
            [ngStyle]="{ 'width: 20px; height: 20px;': isAddToPipelineLoading }">
            {{isAddToPipelineLoading ? '' : 'Add to Pipeline'}}
          </span>

  </button>

  @if(isDropdownOpen) {
    <div class="custom-dropdown-menu">

      <!-- Search -->
      <div class="custom-dropdown-search">
        <i class="fa fa-search search-icon"></i>
        <input data-testid="auto-app-add-to-pipeline-input-1"
          type="text"
          placeholder="Search for..."
          [formControl]="pipelineSearchControl"
          class="search-input">
      </div>

      <!-- List -->
      <ul class="custom-dropdown-list">
        @for(pipeline of filteredPipelines; track pipeline.projectnumber) {
          <li
            class="custom-dropdown-item"
            [class.active]="selectedPipeline?.projectnumber === pipeline.projectnumber"
            [class.disabled]="!canAddToProject(pipeline.projectnumber)"
            [attr.aria-disabled]="!canAddToProject(pipeline.projectnumber)"
            [matTooltip]="isCandidateInPipeline(pipeline.projectnumber) ? alreadyInPipelineTooltip : ''"
            (click)="canAddToProject(pipeline.projectnumber) && addToPipeline(pipeline)">
            {{ pipeline.projectname | titlecase }}
          </li>
        }
        @if(filteredPipelines.length === 0) {
          <li class="custom-dropdown-item no-results">No results found</li>
        }
      </ul>

      <!-- Create New -->
      <!-- <div class="custom-dropdown-footer" (click)="createNewCampaign()">
        <i class="fa fa-plus mr-2"></i>
        <span>Create New Project</span>
      </div> -->

    </div>
  }
</div>
} @else {

<div class="btn-group hire-btn-group w-100" (clickOutside)="closeDropdown()">
  <button data-testid="auto-app-add-to-pipeline-button-2" type="button w-100" class="btn-trms-medium"
 [ngStyle]="(isAddToPipelineLoading || isCandidateInPipeline(projectnumber)) ? {'opacity': '0.5'} : null"
  (click)="!isAddToPipelineLoading && addToPipeline()" [class.loading-state]="isAddToPipelineLoading" [disabled]="isAddToPipelineLoading || isCandidateInPipeline(projectnumber)" [matTooltip]="isCandidateInPipeline(projectnumber) ? alreadyInPipelineTooltip : ''">
         <span [ngClass]="{ 'spinner-border spinner-size': isAddToPipelineLoading }" style="width: 11px; height: 11px;">
            {{isAddToPipelineLoading ? '' : 'Add to Pipeline'}}
          </span>
</button>
@if(!isAddToPipelineLoading) {
  <button data-testid="auto-app-add-to-pipeline-button-3" type="button" class="btn-trms-medium dropdown-toggle dropdown-toggle-split" [ngClass]="{'rotate-caret':isDropdownOpen}"   (click)="!isAddToPipelineLoading && toggleDropdown()">
    <span class="visually-hidden">Toggle Dropdown</span>
  </button>
}
   @if(isDropdownOpen) {
    <div class="custom-dropdown-menu">

      <!-- Search -->
      <div class="custom-dropdown-search">
        <i class="fa fa-search search-icon"></i>
        <input data-testid="auto-app-add-to-pipeline-input-2"
          type="text"
          placeholder="Search for..."
          [formControl]="pipelineSearchControl"
          class="search-input">
      </div>

      <!-- List -->
      <ul class="custom-dropdown-list">
        @for(pipeline of filteredPipelines; track pipeline.projectnumber) {
          <li
            class="custom-dropdown-item"
            [class.active]="selectedPipeline?.projectnumber === pipeline.projectnumber"
            [class.disabled]="!canAddToProject(pipeline.projectnumber)"
            [attr.aria-disabled]="!canAddToProject(pipeline.projectnumber)"
            [matTooltip]="isCandidateInPipeline(pipeline.projectnumber) ? alreadyInPipelineTooltip : ''"
            (click)="canAddToProject(pipeline.projectnumber) && addToPipeline(pipeline)">
            {{ pipeline.projectname | titlecase }}
          </li>
        }
        @if(filteredPipelines.length === 0) {
          <li class="custom-dropdown-item no-results">No results found</li>
        }
      </ul>

      <!-- Create New -->
      <!-- <div class="custom-dropdown-footer" (click)="createNewCampaign()">
        <i class="fa fa-plus mr-2"></i>
        <span>Create New Project</span>
      </div> -->

    </div>
  }
</div>
}
</div>

@if(successMessage) {
<ngb-alert class="ngb-alert" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>
}

@if(errorMessage) {
<ngb-alert class="ngb-alert error-message-alert"  type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
}


